module.exports = __webpack_public_path__ + "img/kekurangan_dokumen.77bcb0aa.svg";